import {Injectable} from "@angular/core";
import { EventGroup } from "@biletix/core/models/event/event-group.model";
import {EventGroupListItem} from "@biletix/core/models/event/event-group-list-item.model";

@Injectable()
export class EventGroupPageStateService {

  // private _currentEventDetail: EventDetail | any;
  private _currentEventGroup: EventGroup | any;
  private _currentEventList: EventGroupListItem[] | any [] = [];

  // getCurrentEventDetail(): EventDetail {
  //   return this._currentEventGroup;
  // }

  setCurrentEventGroup(eventGroup: EventGroup) {
    this._currentEventGroup = eventGroup;
  }

  getCurrentEventGroup(): EventGroup {
    return this._currentEventGroup;
  }

  getCurrentEventList(): EventGroupListItem [] {
    return this._currentEventList;
  }
  
  setCurrentEventList(eventList: EventGroupListItem []) {
    this._currentEventList = eventList;
    //this._currentPerformanceList.forEach(el => { el.active = (el.status == 's01_onsale')});
  }

}
